module.exports = __webpack_public_path__ + "static/media/login-plantas.85877378.png";